import { BotConfigContext } from "@/context/BotConfigProvider"
import { useContext } from "react"

function useBotConfig() {
    const botConfig = useContext(BotConfigContext);
    if (!botConfig) {
        throw new Error('useBotConfig must be used within a BotConfigProvider');
    }
    return botConfig

}

export default useBotConfig